import { render, staticRenderFns } from "./selectSettings.vue?vue&type=template&id=073e3484"
import script from "./selectSettings.vue?vue&type=script&lang=js"
export * from "./selectSettings.vue?vue&type=script&lang=js"
import style0 from "./selectSettings.vue?vue&type=style&index=0&id=073e3484&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports